import { useFormik } from "formik";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import { ComonIcons } from "../contents/commonIcons";
import { setFreezeAllModalOpen } from "../redux/actions/member/memberAction";
import Title from "./title";
import * as Yup from "yup";
import ReactDatePicker from "react-datepicker";
import { freezeAll } from "../redux/actions/api/apiAction";

export const FreezeAllModal = ({ selectedMember }) => {
  const dispatch = useDispatch();
  const { freezeAllModalOpen } = useSelector((state) => state.member);
  const toggle = () => dispatch(setFreezeAllModalOpen(!freezeAllModalOpen));
  const [timer, setTimer] = React.useState(10);

  React.useEffect(() => {
    if (freezeAllModalOpen)
      timer > 0 && setTimeout(() => setTimer(timer - 1), 1000);
    if (!freezeAllModalOpen) setTimer(10);
  }, [timer, freezeAllModalOpen]);

  const initialValues = {
    freezeStartDate: moment().valueOf(),
    duration: undefined,
  };

  const hanldeSubmit = (values) => {
    const freezeEndDate = moment(values.freezeStartDate)
      .clone()
      .add(values.duration, "days")
      .endOf("D")
      .valueOf();
    const request = {
      ...values,
      freezeEndDate,
      arrayOfSelectedIds: selectedMember.length ? selectedMember : "",
    };
    dispatch(freezeAll(request));
  };

  const validationSchema = Yup.object().shape({
    freezeStartDate: Yup.number().required("Freeze start date is required"),
    duration: Yup.number().required("Freeze duration is required"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: hanldeSubmit,
    validationSchema: validationSchema,
  });

  return (
    <Modal
      centered={true}
      size={selectedMember.length ? "md" : "lg"}
      className="large-pop adding-popup "
      isOpen={freezeAllModalOpen}
      toggle={toggle}
    >
      <ModalBody>
        <div className="bg-white mx-2">
          <div className="d-flex align-items-center border-bottom-1 pb-4 mb-4">
            <div className="d-inline-flex ">
              <Title title="Freeze All" />
            </div>
            <div className="d-inline-flex ml-auto">
              <div className="close-icons pb-0">
                <div className="text-right">
                  <span
                    className="svg-block"
                    onClick={() => {
                      toggle();
                    }}
                  >
                    {ComonIcons.closeBlack}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <Row>
            <Col md={12}>
              <h3 className="text-danger text-center">Warning</h3>
              <h4 className="mx-3 text-center mb-5">
                {selectedMember.length
                  ? " Select the freezing interval of the membership for selected members"
                  : "Once confirmed, all members will no longer be able to perform  any activity on the app or the web. They will also no longer be able to book or cancel classes or appointments or perform any purchasing transactions."}
              </h4>
            </Col>
          </Row>
          <form onSubmit={formik.handleSubmit}>
            <Row>
              <Col md={12}>
                <FormGroup className="custom-inputs mb-md-0 ">
                  <ReactDatePicker
                    name="freezeStartDate"
                    className={
                      formik.errors.freezeStartDate &&
                      formik.touched.freezeStartDate &&
                      "is-invalid"
                    }
                    dateFormat="dd/MM/yyyy"
                    selected={new Date(formik.values.freezeStartDate)}
                    onChange={(date) =>
                      formik.setFieldValue(
                        "freezeStartDate",
                        moment(date).valueOf()
                      )
                    }
                  />
                  <Label for="date">Start Date</Label>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup className="custom-inputs mb-md-0 ">
                  <Input
                    name="duration"
                    type="number"
                    placeholder="Days"
                    className={` mt-3 mb-5
                     ${formik.errors.duration &&
                       formik.touched.duration &&
                       "is-invalid"}
                    `}
                    onChange={formik.handleChange}
                    min={1}
                  />
                  <Label for="date">Duration</Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12} className="d-flex justify-content-center">
                <button
                  className="btn btn-primary btn-small mr-3"
                  onClick={toggle}
                >
                  Cancel
                </button>
                <button
                  disabled={timer > 0}
                  className="btn btn-danger btn-small"
                  type="submit"
                >
                  Freeze All {timer > 0 && `(${timer})`}
                </button>
              </Col>
            </Row>
          </form>
        </div>
      </ModalBody>
    </Modal>
  );
};
